<template>
  <div id="Pmi">
    <section id="PmiBanner" class="pmi-banner-container pb-5">
      <div class="content-container">
        <div class="pmi-banner px-3">
          <h1 class="pmi-banner-title mb-3 brand-highlight-1">
            Your Online Account
          </h1>
          <div class="pmi-image-wrapper">
            <img
              src="https://media.spectrum.life/assets/axa/pmihero.jpg"
              class="img-fluid pmi-hero-image"
              alt="PMI hero"
            />
          </div>
          <div class="pmi-banner-text">
            <p>
              Find out everything you need to know about making the most of your
              health and wellbeing benefits in your online account. You'll find:
            </p>
            <ul class="py-2">
              <li>
                <p class="p-text">
                  See details of all the health and wellbeing benefits and
                  services you have available
                </p>
              </li>
              <li>
                <p class="p-text">
                  Find guidance on how to get the support and treatment you need
                </p>
              </li>
              <li>
                <p class="p-text">
                  Access your member handbook to understand what you're covered
                  for
                </p>
              </li>
              <li>
                <p class="p-text">Keep track of claims</p>
              </li>
              <li>
                <p class="p-text">Update your details</p>
              </li>
            </ul>
            <p>
              To access your online account, you'll need your membership number
              to register on your first visit.
            </p>
          </div>
          <div class="pmi-button-wrapper">
            <b-button
              class="px-5"
              variant="cta"
              size="lg"
              squared
              @click="goToOnlineAccount"
            >
              Go to your online account
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Pmi",
  methods: {
    goToOnlineAccount() {
      window.open(
        "https://auth.axahealth.co.uk/pppauth.onmicrosoft.com/b2c_1a_signupsignin_authcodegrant_r3/oauth2/v2.0/authorize?client_id=1f241bd8-1431-44c5-acdf-25f5cf810db8&redirect_uri=https%3A%2F%2Fwww.axahealth.co.uk%2Fsignin-oidc&response_type=code&scope=openid%20https%3A%2F%2Fpppauth.onmicrosoft.com%2Fhubs%2Fuser_impersonation&response_mode=form_post&nonce=639098858448925620.ZjQxNTM1ZjQtMTY5My00ZWJiLTgzYzYtNTQ1ZjdlNzY1NjgxNWFmNDZjNWMtZTFjYS00N2VkLWI3NGYtODljNDUxZmEzZmJj&state=CfDJ8MPICyxcbkZNp_A_b-Bq8CmQ9GaNQL-h7HzViktjqRhkKMayGdEymkw4yeCuNd7TFKusdKjIHi8WbOg8STSdAqvM6idyrnIiX2fCaEZ3qzmk5ShA8gq83nnDWPDUhnVzLg7u_GEQrFrHDYZZkMpMCKZoUv87w6q8UISolhfsTv3PLHMujV3yMPkLiIkqnNlM8SHxN-t1g2M-3WFWDIrV3WYQpm5CO8rqd59eRTmppKyRneA7LKKL0zY7wZATi2IZxosmWbnIaQ2qlhkK57MXrh3CD8LwoYgNkAFDntpOtj1_aa3NnUYfofH8XdRbSUPNlQ&x-client-SKU=ID_NET8_0&x-client-ver=7.1.2.0",
        "_blank"
      );
    }
  }
};
</script>

<style lang="less">
#Pmi {
  background-color: #fafafa;

  .pmi-banner-container {
    .pmi-banner {
      padding-top: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .pmi-banner-title {
      font-size: 4.2rem;
      font-weight: bold;
      padding-bottom: 25px;
      width: 100%;
    }

    .pmi-image-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-bottom: 40px;

      .pmi-hero-image {
        border-radius: 8px;
        max-width: 600px;
        width: 100%;

        @media only screen and (max-width: 576px) {
          max-width: 100%;
        }
      }
    }

    .pmi-banner-text {
      font-size: 1.6rem;
      width: 100%;
    }

    .pmi-button-wrapper {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 32px;
    }
  }

  ul {
    padding-left: 15px;
  }
}
</style>
